var path = 'infrastructure/directives/views/search-box.html';
var html = "<label class=search-box> <i class=\"fa fa-search clickable\" ng-click=onSearchClicked(inputText)></i> <input type=text class=form-control ng-model=inputText placeholder={{placeholder}} ng-change=onTextChanged(inputText) focus-me=autoFocus> </label>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/views/search-box.html
// module id = 4408258344532825
// module chunks = 1